import { forwardRef, useRef, useState, useEffect } from "react";
import { Link } from "react-router-dom";

/*eslint-disable */

declare const window: any;

interface VersionesVehiculosComponentProps {
  versiones: any;
}

const VersionesVehiculosComponent = forwardRef<
  HTMLDivElement,
  VersionesVehiculosComponentProps
>(({ versiones }, ref) => {
  const scrollContainerRef: any = useRef(null);
  const [currentIndex, setCurrentIndex] = useState(0); // Estado para el índice actual del scroll
  const [windowWidth, setWindowWidth] = useState(window.innerWidth); // Estado para guardar el ancho de la pantalla

  // Función para actualizar el ancho de la ventana
  const handleResize = () => {
    setWindowWidth(window.innerWidth);
  };

  useEffect(() => {
    // Añadir el event listener para el resize
    window.addEventListener("resize", handleResize);

    // Limpiar el event listener al desmontar el componente
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // Función para mover el scroll hacia la izquierda (prev)
  const handlePrev = () => {
    scrollContainerRef.current.scrollBy({
      left: windowWidth < 768 ? -310 : -394, // Desplaza hacia la izquierda
      behavior: "smooth", // Scroll suave
    });
  };

  // Función para mover el scroll hacia la derecha (next)
  const handleNext = () => {
    scrollContainerRef.current.scrollBy({
      left: windowWidth < 768 ? 310 : 394, // Desplaza hacia la derecha
      behavior: "smooth",
    });
  };

  return (
    <div className="versiones-vehiculos-detail-component" ref={ref}>
      <div className="title-versiones-vehiculos-detail-component">
        Encuentra el Hyundai que mejor se adapte a ti
      </div>
      <div
        className="btn-carrousel-versiones-vehiculos-detail-component prev"
        onClick={handlePrev}
      >
        <img src="../assets/01_Home/Icon_Left.svg" alt="Desplazar a la izquierda" />
      </div>
      <div
        className="carrousel-versiones-vehiculos-detail-component"
        ref={scrollContainerRef}
      >
        {versiones?.version?.sort((a:any, b:any) => a.order - b.order).map((item: any, index: any) => (
          <div
            key={index}
            className={`item-versiones-vehiculos-detail-component`}
          >
            <div className={`title-item-versiones-vehiculos-detail-component`}>
              {item.title}
            </div>
            <div
              className={`asset-item-versiones-vehiculos-detail-component`}
              style={{ backgroundImage: `URL(https://manager.hyundaicolombia.co/${item?.image?.url})` }}
            ></div>
            <div className={`subtitle-precio-item-versiones-vehiculos-detail-component`}>
              Disponible desde
            </div>
            <div className={`precio-item-versiones-vehiculos-detail-component`}>
              {item.price}
            </div>
            <div className="separador-item-versiones-vehiculos-detail-component"></div>
            <div className={`colores-item-versiones-vehiculos-detail-component`}>
              {item?.colors?.map((color: any, index: number) => (
                <div
                  key={index}
                  className={`color-item-versiones-vehiculos-detail-component`}
                  style={{ backgroundColor: color?.color_hexa }}
                ></div>
              ))}
            </div>
            <div className={`opciones-item-versiones-vehiculos-detail-component`}>
              <img src={`https://manager.hyundaicolombia.co/${item?.icon1?.url}`} alt={item?.text1 || "Ícono de opción 1"} />
              <div>{item?.text1}</div>
            </div>
            <div className={`opciones-item-versiones-vehiculos-detail-component`}>
              <img src={`https://manager.hyundaicolombia.co/${item?.icon2?.url}`} alt={item?.text2 || "Ícono de opción 2"} />
              <div>{item?.text2}</div>
            </div>
            <div className={`opciones-item-versiones-vehiculos-detail-component`}>
              <img src={`https://manager.hyundaicolombia.co/${item?.icon3?.url}`} alt={item?.text3 || "Ícono de opción 3"} />
              <div>{item?.text3}</div>
            </div>
            <Link
              to={item?.url_quote !== null && item?.url_quote !== undefined ? `/vehiculos/${item?.url_quote}` : `#`}
              className="mas-item-versiones-vehiculos-detail-component"
            >
              Cotiza
            </Link>
            {item?.url_reserve ? <a
              href={`${item?.url_reserve}`}
              className="cotiza-item-versiones-vehiculos-detail-component"
            >
              Reserva en línea
            </a> : null}
          </div>
        ))}
      </div>
      <div
        className="btn-carrousel-versiones-vehiculos-detail-component next"
        onClick={handleNext}
      >
        <img src="../assets/01_Home/Icon_Right.svg" alt="Desplazar a la derecha" />
      </div>
    </div>
  );
});

export default VersionesVehiculosComponent;
